import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="w-full bg-[#162230] text-white">
       
        {/* Watermark Text */}
        <h1
        className="fixed top-40 left-1/2 -translate-x-1/2 
        font-black text-white/10 tracking-tight leading-none 
        pointer-events-none select-none z-20"
        style={{ fontSize: "clamp(5rem, 18vw, 15rem)" }}
        >
        BROADBOY
        </h1>

        <h1
        className="fixed top-[22rem] left-1/2 -translate-x-1/2 
        font-black text-white/10 tracking-tight leading-none 
        pointer-events-none select-none z-20"
        style={{ fontSize: "clamp(4rem, 15vw, 13rem)" }}
        >
        ADVENTURES
        </h1>

      <div className="max-w-7xl mx-auto flex gap-12 px-6 md:px-12 relative">
        
        {/* LEFT COLUMN — FIXED SIDEBAR */}
        <aside className="w-96 hidden lg:flex flex-col sticky top-40 h-fit pr-12 pb-16">

          {/* Last Updated */}
          <p className="text-sm tracking-wide text-white/70 mb-3">
            Last Updated: April 20, 2025
          </p>

          {/* Main Title */}
          <h1 className="text-[57px] font-semibold leading-[1.05] tracking-tight text-white">
            Terms of
          </h1>
          <h1 className="text-[57px] font-semibold leading-[1.05] tracking-tight text-white mb-10">
            Service
          </h1>

          {/* Contact Info Text */}
          <h3 className="text-sm font-normal text-white/90 mb-10 leading-relaxed">
            For any questions or concerns about this Privacy Policy, please contact us using the information below.
          </h3>

          {/* Contact Info Items */}
            <div className="grid grid-cols-[24px_auto] items-center gap-x-4 gap-y-6 text-[15px]">

              {/* Phone */}
              <Phone size={20} className="text-white" strokeWidth={1.6} />
              <p className="text-white/70 font-light text-lg">
                +1 716-579-1720
              </p>

              {/* Email */}
              <Mail size={20} className="text-white" strokeWidth={1.6} />
              <p className="text-white/70 font-light text-lg">
                info@broadboyadventures.com
              </p>

              {/* Address */}
              <MapPin size={20} className="text-white" strokeWidth={1.6} />
              <p className="text-white/70 font-light text-lg leading-snug">
                9th floor 910, Al Hafeez Heights,<br />
                Gulberg Lahore, Pakistan
              </p>

            </div>

        </aside>

        {/* 🔥 SEPARATOR LINE LIKE FRAMER */}
        <div className="hidden lg:flex">
          <div className="w-[3px] bg-white/10 rounded-full h-full"></div>
        </div>

        {/* RIGHT COLUMN — SCROLLABLE CONTENT */}
        <section className="relative top-40 w-full lg:w-2/3 space-y-12 leading-relaxed text-lg text-justify">
        <div>
            <h4 className="font-semibold text-2xl mb-3">1. Acceptance of Terms</h4>
            <p className="font-light">
            By accessing or using BroadBoy Adventures (the “Website”) and/or booking any expedition or climbing activity, you agree to comply with and be bound by these Terms of Service (“Terms”). If you do not agree with these Terms or if you cannot comply with local regulations do not use our services or participate in expeditions.
            </p>
        </div>

        <div>
            <h4 className="font-semibold text-2xl mb-3">2. Compliance with Pakistani Regulations & Permits</h4>
            <p className="font-light">
            All climbing and mountaineering expeditions in Pakistan must comply with the regulations established by the Tourism Division (or other relevant government authorities) governing peak permits, environmental regulations, and security guidelines. 
            By booking with BroadBoy Adventures, you confirm that either you hold valid permits (if required) or you authorize us to apply for such permits on your behalf.  
            Failure to obtain required permits or to comply with official procedures may result in expedition cancellation and forfeiture of fees.
            </p>
        </div>

        <div>
            <h4 className="font-semibold text-2xl mb-3">3. Use of the Website & Booking System</h4>
            <p className="font-light">
            You agree to use the Website only for lawful purposes and in accordance with these Terms. You confirm all personal information provided is accurate.  
            Any fraudulent activity, misrepresentation, or misuse of booking or communication channels will result in immediate termination of access and cancellation of any bookings.
            </p>
        </div>

        <div>
            <h4 className="font-semibold text-2xl mb-3">4. Intellectual Property</h4>
            <p className="font-light">
            All content on BroadBoy Adventures including photos of mountains, routes, branding, guides material, and digital assets remains our intellectual property. You may not copy, redistribute, or use such content for commercial or public purposes without prior written consent.
            </p>
        </div>

        <div>
            <h4 className="font-semibold text-2xl mb-3">5. Risk Acknowledgment & Safety Compliance</h4>
            <p className="font-light">
            Mountaineering and trekking in Pakistan (particularly in high-altitude regions) involve substantial risks: terrain, weather, altitude sickness, environmental hazards, and remote location logistics.  
            By participating, you acknowledge these risks. You also agree to follow all safety protocols, guidance, and security instructions provided by our team, local authorities, or designated liaison officers.  
            You must disclose all relevant medical conditions and physical limitations honestly prior to booking.
            </p>
        </div>

        <div>
            <h4 className="font-semibold text-2xl mb-3">6. Permit Obligations and Environmental Responsibility</h4>
            <p className="font-light">
            Where required by Pakistani law or local regulations, you must obtain or authorize the procurement of mountaineering permits, royalty payments, and route permissions before commencing any expedition. 
            All participants agree to respect local environmental rules, leave no trace, and follow waste disposal and clean-camping standards. Any damage to protected areas or failure to comply may result in legal consequences, fines, or bans from future expeditions.
            </p>
        </div>

        <div>
            <h4 class="font-semibold text-2xl mb-3">7. Limitation of Liability & Insurance</h4>
            <p className="font-light">
            BroadBoy Adventures, its guides, partners, or staff are not liable for injuries, losses, deaths, or damages arising from participation in expeditions, except in cases of proven gross negligence.  
            We strongly recommend all climbers/participants secure appropriate travel, rescue, and medical insurance before embarking.  
            By proceeding with booking, you accept that you take full responsibility for your personal safety and equipment.
            </p>
        </div>

        <div>
            <h4 className="font-semibold text-2xl mb-3">8. Governing Law & Dispute Resolution</h4>
            <p className="font-light">
            These Terms and any disputes arising from them will be governed by the laws applicable within Pakistan.  
            Any legal action or claim must be filed in the competent courts of the relevant jurisdiction in Pakistan.  
            If any provision of these Terms is found invalid or unenforceable, the remaining provisions remain in full effect.
            </p>
        </div>
        </section>


      </div>
    </div>
  );
}
